module.exports = __webpack_public_path__ + "img/MaskGroup 2879.b257fe7a.svg";